// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MDrtNOo94gUMzhHozNuTQ","tableWrapper":"ypNnJfl2QJRfKwfwZGBiH","tableWrapperResponsive":"_44NSzhcePooVfy9Eljlbp"};